import React, { useEffect, useMemo, useRef, useState } from "react";
import { Image, Modal } from "react-bootstrap";
import xCircle from "../../../assets/icons/x-circle.svg";
import adddoc from "../../../assets/images/Plus.svg";
import PhotoIcon from "../../../assets/icons/PhotoIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  Adminaccess,
  GroupInfo,
  RemoveGroupAdmin,
  UpdateGroupInfo,
  UserLeaveGroup,
  getChatRooms,
  emptyLeaveGroupState,
} from "../../../redux/actions/chatActions";
import { AiOutlineDelete } from "react-icons/ai";
import { API_URL } from "../../../redux/constants/type";

const GroupInfoDetail = ({
  fetchTransChatList,
  handleMuteNotification,
  rightSideMenuStat,
  setRightSideMenuStat,
  setShowAdminDrop,
  groupDetails,
  selectedRoom,
  showAdminDrop,
  setAddMemberGroupList,
  setGroupInfoDetail,
  UpdateConversationList,
  setSelectedRoom,
}) => {
  const dispatch = useDispatch();
  const inputFile = React.useRef(null);
  const refPaymentTypeDropDownContainer = useRef();
  const currentUserId = window.localStorage.getItem("userid");
  const t = (key) => fetchTransChatList?.[key] || "";

  const RemoveGroupAdminApiRes = useSelector(
    (state) => state.chat.RemoveGroupAdmin,
  );
  const UserLeaveGroupRes = useSelector((state) => state.chat.UserLeaveGroup);
  const AdminAccessRes = useSelector((state) => state.chat.Adminaccess);
  const AddUserToGroupReq = useSelector((state) => state.chat.AddUserToGroup);

  const [popups, setPopups] = useState(false);
  const [showAdminDropIndex, setShowAdminDropIndex] = useState();
  const [popups2, setPopups2] = useState(false);
  const [popups3, setPopups3] = useState(false);
  const [popup3Id, setPopup3Id] = useState(-1);
  const [selectedValues, setSelectedValues] = useState([]);

  const handleClose = () => setPopups(false);
  const handleClose3 = () => setPopups3(false);
  const handleClose2 = () => {
    setPopups2(false);
  };

  const onButtonClick = () => {
    inputFile.current.click();
  };

  useEffect(() => {
    setPopups2(false);
    dispatch(GroupInfo(currentUserId, selectedRoom?.groupid));
  }, [AdminAccessRes, AddUserToGroupReq]);

  useEffect(() => {
    if (UserLeaveGroupRes.status === true) {
      // window.location.reload();
      dispatch(getChatRooms(currentUserId));
      setRightSideMenuStat(!rightSideMenuStat);
      setShowAdminDrop(false);
      dispatch(emptyLeaveGroupState());
    }
  }, [UserLeaveGroupRes]);

  useEffect(() => {
    setPopups3(false);
    dispatch(GroupInfo(currentUserId, selectedRoom?.groupid));
  }, [UserLeaveGroupRes, RemoveGroupAdminApiRes]);

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;
    if (isChecked) {
      setSelectedValues([...selectedValues, value]);
    } else {
      setSelectedValues(selectedValues.filter((v) => v !== value));
    }
  };

  const handleFileChange = (e, groupid, groupname) => {
    const target = e.target.files[0];
    let formData = new FormData();
    formData.append("file", target);
    axios
      .put(`${API_URL}/api/Files/UploadToS3`, formData)
      .then(function (response) {
        if (response != null) {
          dispatch(UpdateGroupInfo(groupid, groupname, response?.data[0]));
          dispatch(GroupInfo(currentUserId, groupid));
        } else {
        }
      })
      .catch(function () {});
  };

  const handleCheckboxChangeAdmin = (event, groupid, userid) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      let reqArray = [{ userid: userid }];
      dispatch(Adminaccess(groupid, reqArray));
    } else {
      dispatch(RemoveGroupAdmin(groupid, userid));
    }
  };

  const onBlurGroupName = (e) => {
    if (selectedRoom && isGroupAdmin) {
      dispatch(
        UpdateGroupInfo(
          selectedRoom.groupid,
          e.target.value,
          selectedRoom.groupicon,
        ),
      );
      UpdateConversationList();
      setSelectedRoom({ ...selectedRoom, groupname: e.target.value });
    }
  };

  const isGroupAdmin = useMemo(() => {
    if (
      groupDetails &&
      groupDetails[0] &&
      Array.isArray(groupDetails[0].groupuser)
    ) {
      return groupDetails[0].groupuser.some(
        (item) =>
          item?.userid === currentUserId && item?.adminaccess === "Admin",
      );
    }
    return false;
  }, [JSON.stringify(groupDetails)]);

  return (
    <div>
      <div
        className="right-sub-chat-style "
        style={{ backgroundColor: "white" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h6 className="ms-3 Group-Details-chat mt-2">
            {t("Group Details")}
          </h6>
          <img
            src={xCircle}
            width={20}
            height={20}
            alt="#"
            onClick={() => {
              setRightSideMenuStat(!rightSideMenuStat);
              setShowAdminDrop(false);
            }}
            s
            className="m-2 cursor-pointer"
          ></img>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="select-icon-chat"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            {groupDetails[0]?.groupicon ? (
              <div
                className="profile-image"
                style={{
                  border: "1px solid #707070",
                  height: "83px",
                  width: "83px",
                  borderRadius: "50%",
                }}
              >
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  src={groupDetails[0]?.groupicon}
                  alt=""
                />
              </div>
            ) : (
              <div className=" group-abri">
                {groupDetails[0]?.groupname?.split(" ")[1]
                  ? `${groupDetails[0]?.groupname
                      ?.split(" ")[0][0]
                      ?.toUpperCase()}${groupDetails[0]?.groupname
                      ?.split(" ")[1][0]
                      ?.toUpperCase()}`
                  : `${groupDetails[0]?.groupname
                      ?.split(" ")[0][0]
                      ?.toUpperCase()}${groupDetails[0]?.groupname
                      ?.split(" ")[0][1]
                      ?.toUpperCase()}`}
              </div>
            )}
            <div className="group-chang-maim-div">
              <div
                className="group-chang-icon justify-content-center d-flex align-items-center flex-column"
                onClick={onButtonClick}
              >
                <img src={PhotoIcon} alt="" width={23} height={19}></img>
                <p className="select-img-text">Select a photo</p>
                <input
                  type="file"
                  id="file"
                  onChange={(e) => {
                    handleFileChange(
                      e,
                      groupDetails[0]?.groupid,
                      groupDetails[0]?.groupname,
                    );
                  }}
                  ref={inputFile}
                  placeholder=""
                  className="custom-file-input  ms-3"
                  style={{ display: "none" }}
                />
              </div>
            </div>
            <div
              className=" mt-2"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="text"
                className="group-name-input"
                readOnly={!isGroupAdmin}
                disabled={!isGroupAdmin}
                defaultValue={groupDetails[0]?.groupname}
                onBlur={onBlurGroupName}
              />
            </div>
            <p className="General-chat">{`${
              groupDetails[0]?.groupmembers +
              " " +
              t("Members")
            }`}</p>
          </div>
        </div>
        <div
          className="General-chat-div"
          style={{
            backgroundColor: "white",
            overflowY: "auto",
            height: "71%",
          }}
        >
          <div className="mt-2  px-3 cardli-member ">
            {/* General */}
            <p className="General-chat  mb-2 pt-2">
              {t("General")}
            </p>

            <div className="d-flex align-items-baseline">
              <p className="Group-created-by mb-0">
                {groupDetails[0]?.groupdescription}
              </p>
            </div>
          </div>

          <div className="mt-3 p-3 cardli-member Notifications-chat-member">
            <p className="General-chat">
              {t("Notifications")}
            </p>
            <div className="d-flex align-items-center gap-2">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="0"
                  id="defaultCheck4"
                  checked={
                    !groupDetails[0]?.isAllowedNotification &&
                    groupDetails[0]?.muteMinutes == 0
                  }
                  onChange={handleMuteNotification}
                />
              </div>
              <label
                htmlFor="defaultCheck4"
                style={{
                  color: "#333333",
                  fontSize: "14px",
                  lineHeight: "17px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                {/* Turn Off */}
                {t("Turn off")}
              </label>
            </div>
            <div className="d-flex align-items-center gap-2">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="30"
                  id="defaultCheck5"
                  checked={
                    !groupDetails[0]?.isAllowedNotification &&
                    groupDetails[0]?.muteMinutes == 30
                  }
                  onChange={handleMuteNotification}
                />
              </div>
              <label
                htmlFor="defaultCheck5"
                style={{
                  color: "#333333",
                  fontSize: "14px",
                  lineHeight: "17px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                {/* Silent for 30 m */}
                {t("Silent for 30 m")}
              </label>
            </div>
            <div className="d-flex align-items-center gap-2">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="1440"
                  id="defaultCheck6"
                  checked={
                    !groupDetails[0]?.isAllowedNotification &&
                    groupDetails[0]?.muteMinutes == 1440
                  }
                  onChange={handleMuteNotification}
                />
              </div>
              <label
                htmlFor="defaultCheck6"
                style={{
                  color: "#333333",
                  fontSize: "14px",
                  lineHeight: "17px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                {/* Silent for 24 H */}
                {t("Silent for 24 h")}
              </label>
            </div>
          </div>
          <div className="m-2 py-2 cardli-member Notifications-chat-member">
            <p className="General-chat ps-2">Actions</p>
            <div className="align-items-center justify-content-between d-flex px-2 mb-2">
              <label
                style={{
                  color: "#333333",
                  fontSize: "14px",
                  lineHeight: "19px",
                }}
              >
                {t("Leave the group")}
              </label>
              <div>
                <label
                  for="switch1"
                  className="toggle"
                  style={{
                    cursor: groupDetails[0]?.isLeave && "not-allowed",
                  }}
                  onClick={() => {
                    if (groupDetails[0]?.isLeave) return;

                    if (groupDetails[0]?.groupuser) {
                      const addminacces = groupDetails[0]?.groupuser.filter(
                        (item) =>
                          item?.userid === currentUserId &&
                          item?.adminaccess === "Admin",
                      );
                      const addminacces2 = groupDetails[0]?.groupuser.filter(
                        (item) =>
                          item?.userid !== currentUserId &&
                          item?.adminaccess === "Admin",
                      );
                      if (
                        addminacces2?.length === 0 &&
                        addminacces[0]?.adminaccess === "Admin"
                      ) {
                        setPopups2(true);
                      } else {
                        setPopups(true);
                      }
                    }
                  }}
                ></label>
              </div>
            </div>
            <div className="align-items-center justify-content-between d-flex px-2 mb-2">
              <label
                style={{
                  color: "#333333",
                  fontSize: "14px",
                  lineHeight: "19px",
                }}
              >
                {t("Add member to group\n\n")}
              </label>
              <Image
                src={adddoc}
                className="me-2 cursor-pointer"
                height={16}
                width={16}
                onClick={() => {
                  if (groupDetails[0]?.groupuser) {
                    const addminacces = groupDetails[0]?.groupuser.filter(
                      (item) =>
                        item.userid === currentUserId &&
                        item?.adminaccess === "Admin",
                    );
                    if (addminacces[0]?.adminaccess === "Admin") {
                      setGroupInfoDetail(false);
                      setAddMemberGroupList(true);
                    }
                  }
                }}
              ></Image>
            </div>
          </div>
          <div className="mt-3 py-3 mx-2 cardli-member Notifications-chat-member">
            {/* Members */}
            <p className="General-chat ps-2">
              {t("Members")}
            </p>
            {groupDetails[0]?.groupuser?.map((user, i) => {
              return (
                <>
                  <div
                    key={user?.userid}
                    className="mb-3 d-flex justify-content-between px-2 position-relative"
                  >
                    <div
                      className="d-flex align-items-center gap-2"
                      onClick={() => {
                        if (showAdminDropIndex === i) {
                          setShowAdminDrop(false);
                          setShowAdminDropIndex(-1);
                        } else {
                          if (groupDetails[0]?.groupuser) {
                            const addminacces =
                              groupDetails[0]?.groupuser.filter(
                                (item) =>
                                  item.userid === currentUserId &&
                                  item?.adminaccess === "Admin",
                              );
                            if (addminacces[0]?.adminaccess === "Admin") {
                              setShowAdminDrop(true);
                              setShowAdminDropIndex(i);
                            }
                          }
                        }
                      }}
                    >
                      {user?.image ? (
                        <div
                          className="profile-image"
                          style={{
                            border: "3px solid #FFFFFF",
                            height: "42px",
                            width: "42px",
                            borderRadius: "50%",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                            src={user?.image}
                            alt=""
                          />
                        </div>
                      ) : (
                        <div
                          className="co-worker-chat1"
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            border: "3px solid rgb(255, 255, 255)",
                            color: "#FFFFFF",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#95A7C6",
                            height: "36px",
                            width: "36px",
                            borderRadius: "50%",
                          }}
                        >
                          {user?.lastname?.toUpperCase()
                            ? user?.firstname.slice(0, 1).toUpperCase() +
                              user?.lastname.slice(0, 1).toUpperCase()
                            : user?.firstname?.slice(0, 1).toUpperCase() +
                              user?.firstname?.slice(1, 2).toUpperCase()}
                        </div>
                      )}
                      <div>
                        <div className="add-group-user-name">{`${
                          user?.firstname + " " + user?.lastname
                        }`}</div>
                        <p className="add-group-user-jobpost">
                          {user?.jobpost}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex">
                      <span className="admin-action">{user?.adminaccess}</span>
                    </div>
                    {showAdminDrop && showAdminDropIndex === i && (
                      <div
                        className="drop-down-admin-action"
                        id="lang-drop-down"
                        ref={refPaymentTypeDropDownContainer}
                      >
                        <div className="d-flex chat-member-action">
                          <div className="action-icon">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="option1"
                                checked={user?.adminaccess === "Admin"}
                                onChange={(e) => {
                                  handleCheckboxChangeAdmin(
                                    e,
                                    groupDetails[0]?.groupid,
                                    user?.userid,
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="action-label">
                            {t("Admin")}
                          </div>
                        </div>
                        <div
                          className="d-flex chat-member-action"
                          onClick={() => {
                            if (groupDetails[0]?.groupuser) {
                              let CountAdminUser =
                                groupDetails[0]?.groupuser.filter(
                                  (x) => x.adminaccess === "Admin",
                                ).length;
                              if (
                                user?.adminaccess === "Admin" &&
                                CountAdminUser <= 1
                              ) {
                                setPopups2(true);
                              } else {
                                setPopups3(true);
                              }
                            }
                            setPopup3Id(i);
                          }}
                        >
                          <div className="action-icon">
                            <AiOutlineDelete height={10} color="#A5A5A5" />
                          </div>
                          <div className="action-label">
                            {" "}
                            {t("Delete")}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <Modal
                    show={popups3 && popup3Id === i}
                    onHide={handleClose3}
                    style={{
                      backgroundColor: "transparent",
                      opacity: 0.9,
                    }}
                    centered
                    className="leave-group-model-custom"
                  >
                    <Modal.Body>
                      <div className="flex_class my-5">
                        <div className="content-custom">
                          Remove {user?.firstname} {user?.lastname} from{" "}
                          <span>"{groupDetails[0]?.groupname}"</span> group?
                        </div>

                        <div className="mt-3 content-custom">
                          {t("Do you want to proceed?")}
                        </div>
                        <div className="mt-5 ">
                          <button
                            className="me-2  btn-no"
                            onClick={() => {
                              setPopups3(false);
                            }}
                          >
                            {t("No")}
                          </button>
                          <button
                            className="ms-2 btn-yes"
                            onClick={() => {
                              dispatch(
                                UserLeaveGroup(
                                  groupDetails[0]?.groupid,
                                  user?.userid,
                                ),
                              );
                            }}
                          >
                            {t("Yes")}
                          </button>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                </>
              );
            })}
          </div>
        </div>
      </div>
      <Modal
        show={popups}
        onHide={handleClose}
        style={{
          backgroundColor: "transparent",
          opacity: 0.9,
        }}
        centered
        className="leave-group-model-content"
        portalClassName="leave-group-model-content"
      >
        <Modal.Body>
          <div className="d-flex flex-column h-100 justify-content-center text-center">
            <div>
              {/* You’ll no longer be able to participate in this group. */}
              {t("You’ll no longer be able to participate in this group.")}
            </div>

            <div className="mt-3 mb-5">
              {/* Do you want to proceed? */}
              {t("Do you want to proceed? ")}
            </div>

            <div className="mt-5 ">
              <button
                className="me-2 w-25 btn-no"
                onClick={() => {
                  setPopups(false);
                }}
              >
                {/* No */}
                {t("No")}
              </button>
              <button
                className="ms-2 w-25 btn-yes"
                onClick={() => {
                  setPopups(false);
                  dispatch(
                    UserLeaveGroup(groupDetails[0]?.groupid, currentUserId),
                  );
                }}
              >
                {/* Yes */}
                {t("Yes")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Please choose an administrator for the group modal */}
      <Modal
        show={popups2}
        onHide={handleClose2}
        style={{
          backgroundColor: "transparent",
          opacity: 0.9,
        }}
        size="lg"
        className="new-admin-popup"
      >
        <Modal.Body>
          <div className=" d-flex justify-content-end p-2">
            <img
              src={xCircle}
              width={20}
              height={20}
              alt="#"
              onClick={() => {
                let reqArray = [];
                selectedValues?.forEach((elements) => {
                  reqArray.push({
                    userid: elements,
                  });
                });
                dispatch(Adminaccess(groupDetails[0]?.groupid, reqArray));
              }}
              className="d-flex justify-content-end cursor-pointer"
            ></img>
          </div>
          <p className="text-center add-group-user-jobpost2 py-3 mb-3">
            {/* Please choose an administrator for the group.  */}
            {t("Please choose an administrator for the group.")}
          </p>
          <form className="form-div">
            {groupDetails[0]?.groupuser
              ?.filter(
                (item) =>
                  item?.userid !== currentUserId &&
                  item?.adminaccess !== "Admin",
              )
              .map((user) => {
                return (
                  <>
                    <div key={user?.userid}>
                      <div className="d-flex justify-content-between">
                        <div className="d-flex gap-2">
                          {user?.image ? (
                            <div
                              className="profile-image"
                              style={{
                                border: "3px solid #707070",
                                height: "42px",
                                width: "42px",
                                borderRadius: "50%",
                              }}
                            >
                              <img
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                                src={user?.image}
                                alt=""
                              />
                            </div>
                          ) : (
                            <div
                              className="co-worker-chat1"
                              style={{
                                fontSize: "14px",
                                color: "#FFFFFF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#95A7C6",
                                height: "36px",
                                width: "36px",
                                borderRadius: "50%",
                                fontWeight: "700",
                              }}
                            >
                              {user?.lastname?.toUpperCase()
                                ? user?.firstname.slice(0, 1).toUpperCase() +
                                  user?.lastname.slice(0, 1).toUpperCase()
                                : user?.firstname?.slice(0, 1).toUpperCase() +
                                  user?.firstname?.slice(1, 2).toUpperCase()}
                            </div>
                          )}
                          <div className="d-flex flex-column">
                            <div className="add-group-user-name">{`${
                              user?.firstname + " " + user?.lastname
                            }`}</div>
                            <div className="add-group-user-jobpost">
                              {user?.jobpost}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex gap-1">
                          <div>
                            <input
                              type="checkbox"
                              name={user?.userid}
                              value={user?.userid}
                              onChange={handleCheckboxChange}
                            />
                          </div>
                          <div
                            style={{
                              fontSize: "11px",
                              color: "#A5A5A5",
                              lineHeight: "20px",
                              fontWeight: "bold",
                            }}
                          >
                            {t("Admin")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            <br />
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default GroupInfoDetail;
